import React from 'react';
import { Routes } from 'react-router-dom';
import ProtectedRouter from 'infrastructure/routing/ProtectedRouter';
import { Route } from 'framework/routing';
import { LEAD_REPORT_PATH, useLeadReportPath } from 'domain/sales/report/routing';
import LeadReportsListPage from 'domain/sales/report/List';
import RawLeadDataReportPage from './RawLeadDataReportPage';
import { GlobalSecurityContext } from 'framework/authorization';
import { LEAD_RAW_DATA_REPORT_PERMISSION, LEAD_REPORT_PERMISSION } from 'domain/sales/report/useLeadReportService';

const LeadReportRouter = () => {
  const { listRoute, rawDataRoute } = useLeadReportPath();

  return (
    <ProtectedRouter basePath={LEAD_REPORT_PATH}>
      <Routes>
        <Route
          path={rawDataRoute}
          element={
            <GlobalSecurityContext permissionToCheck={LEAD_RAW_DATA_REPORT_PERMISSION}>
              <RawLeadDataReportPage />
            </GlobalSecurityContext>
          }
        />
        <Route
          path={listRoute}
          element={
            <GlobalSecurityContext permissionToCheck={LEAD_REPORT_PERMISSION}>
              <LeadReportsListPage />
            </GlobalSecurityContext>
          }
        />
      </Routes>
    </ProtectedRouter>
  );
};

LeadReportRouter.getRouterPath = () => '/sale/report/lead/*';

export default LeadReportRouter;
